/* eslint-disable react/jsx-no-constructed-context-values */
import { ComponentProps, createContext, FC, ReactElement, useContext, useReducer } from 'react';
import { AppModel } from './mappers/AppTypesMapper';
import { initialAppState, appReducer } from './reducers/AppReducer';
import { setAppData, setApplicationName, setMsalConfigData } from './actions/AppActions';

interface AppContextInterface {
  readonly appState: AppModel;
  readonly updateAppData: () => void;
  readonly setAppName: (applicationName: string) => void;
  readonly setMsalAuthConfig: (authConfig: any) => void;
}

const AppContext = createContext<AppContextInterface>({} as AppContextInterface);

export const useAppContext = (): AppContextInterface => useContext(AppContext);

export const AppContextProvider = ({
  children,
}: ComponentProps<FC<any>> & { children: ReactElement }): JSX.Element => {
  const [appState, dispatch] = useReducer(appReducer, initialAppState);

  const updateAppData = (): void => {
    setAppData(dispatch, {});
  };

  const setAppName = (applicationName: string): void => {
    setApplicationName(dispatch, { applicationName });
  };

  const setMsalAuthConfig = (authConfig: any): void => {
    setMsalConfigData(dispatch, { authConfig });
  };

  return (
    <AppContext.Provider value={{ appState, updateAppData, setAppName, setMsalAuthConfig }}>
      {children}
    </AppContext.Provider>
  );
};
